export default __webpack_public_path__ + "static/media/marketing-icon.d9d73d1e.png";